import React from "react"
import { Link } from "gatsby"
import IconSidebarTab1 from "../icons/iconSidebarTab1.svg"
import IconSidebarTab2 from "../icons/iconSidebarTab2.svg"
import IconSidebarTab3 from "../icons/iconSidebarTab3.svg"
import IconSidebarTab4 from "../icons/iconSidebarTab4.svg"

function SidebarHeader(props) {
  return (
    <Link to={props.link} className="sidebarHeader" activeClassName="selected">
      <div className="sideBarHeaderContent">
        <div className="headerLogo">{props.logo}</div>
        <div className="headerLogo compact">{props.compactLogo}</div>
      </div>
    </Link>
  )
}

function SidebarTab(props) {
  const { selected } = props
  switch(selected) {
    case 'true':
      return (
        <Link to={props.link} className="sidebarTab selected" activeClassName="selected">
          <div className="tabIcon">{props.icon}</div>
          <div className="tabTitle">{props.title}</div>
        </Link>
      )
    default:
      return (
        <Link to={props.link} className="sidebarTab" activeClassName="selected">
          <div className="tabIcon">{props.icon}</div>
          <div className="tabTitle">{props.title}</div>
        </Link>
      )
  }
}

function SidebarFooter(props) {
  return (
    <Link to={props.link} className="sidebarFooter" activeClassName="selected">
      <div className="separator" />
      <div className="sideBarFooterContent">
        <div className="profilePicture">{props.profilePicture}</div>
        
        <div className="profileDetails">
          <div className="profileDetailsName">{props.profileName}</div>
          <div className="profileDetailsRole">{props.profileRole}</div>
        </div>
      </div>
    </Link>
  )
}

export default function SidebarNavigation(props) {
  const { compact } = props
  switch(compact) {
    case 'true':
      return (
        <div className="sidebarNavigation compact">
          <SidebarHeader
            link=""
            logo=""
            compactLogo=""
          />

          <div className="sidebarTabs">
            <SidebarTab
              link="/"
              icon={<IconSidebarTab1 />}
              title="Components"
              selected={props.selectTab1}
            />

            <SidebarTab
              link="/visuals"
              icon={<IconSidebarTab2 />}
              title="Visuals"
              selected={props.selectTab2}
            />

            <SidebarTab
              link="/icons"
              icon={<IconSidebarTab3 />}
              title="Icons"
              selected={props.selectTab3}
            />

            <SidebarTab
              link="/experiments"
              icon={<IconSidebarTab4 />}
              title="Experiments"
              selected={props.selectTab4}
            />
          </div>

          <SidebarFooter
            link="/profile"
            profilePicture=""
            profileName="Lighthouse"
            profileRole="View profile"
          />
        </div>
      )
    default:
      return (
        <div className="sidebarNavigation">
          <SidebarHeader
            link=""
            logo=""
            compactLogo=""
          />

          <div className="sidebarTabs">
            <SidebarTab
              link="/"
              icon={<IconSidebarTab1 />}
              title="Components"
              selected={props.selectTab1}
            />

            <SidebarTab
              link="/visuals"
              icon={<IconSidebarTab2 />}
              title="Visuals"
              selected={props.selectTab2}
            />

            <SidebarTab
              link="/icons"
              icon={<IconSidebarTab3 />}
              title="Icons"
              selected={props.selectTab3}
            />

            <SidebarTab
              link="/experiments"
              icon={<IconSidebarTab4 />}
              title="Experiments"
              selected={props.selectTab4}
            />
          </div>

          <SidebarFooter
            link="/profile"
            profilePicture=""
            profileName="Lighthouse"
            profileRole="View profile"
          />
        </div>
      )
  }
}
